// extracted by mini-css-extract-plugin
export default {"language-description":"FdChatAudience_language-description__xwThi"};